// extracted by mini-css-extract-plugin
export default {"container":"rsa-z","tab":"ssa-z","selected":"tsa-z"};